
// === FILE HEADER: TileOverlayLayer.js ===
// Renders animated overlays, solved indicators, and effects above the board.
// This layer is absolutely positioned and covers the board area.
// Only dynamic/animated overlays should be rendered here.
// All static overlays are now handled by TileLayer (grid-based).
// Last updated: 2025-07-28

import React from 'react';
import pcModule from './TileOverlayLayer.pc.module.css';
import mobileModule from './TileOverlayLayer.mobile.module.css';
import useSelectedCssModule from '../hooks/useSelectedCssModule';


// TODO: Move all animation/effect logic from legacy TileLayer to this component as needed.
function TileOverlayLayer({ animatedOverlays = [], solvedIndicators = [], effects = [] }) {
  const styles = useSelectedCssModule(pcModule, mobileModule);
  // All overlays are expected to be absolutely positioned children (dynamic/animated only)
  return (
    <div className={styles.tileOverlayLayer}>
      {animatedOverlays.map((overlay, i) => React.cloneElement(overlay, { key: `anim-${i}` }))}
      {solvedIndicators.map((indicator, i) => React.cloneElement(indicator, { key: `solved-${i}` }))}
      {effects.map((effect, i) => React.cloneElement(effect, { key: `effect-${i}` }))}
    </div>
  );
}

export default TileOverlayLayer;
